import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { ReplaySubject, Subject } from 'rxjs'
import { debounceTime, delay, tap, filter, map, takeUntil } from 'rxjs/operators'
import { SharedService } from '../../@core/services/shared.service'
import { UserAdminService } from '../../@core/services/user-admin.service'
import { PvsResponse } from '../../@core/services/pvs-request.service'

interface User {
    id: number
    saintsName?: string
    firstName?: string
    lastName?: string
    phoneNumber?: string
}

@Component({
    selector: 'app-user-selection',
    templateUrl: './user-selection.component.html',
    styleUrls: ['./user-selection.component.scss'],
})
export class UserSelectionComponent implements OnInit, OnDestroy {
    @Input()
    getAllUsersForAdmin: boolean = false

    @Input()
    userId: number
    @Output()
    userIdChange: EventEmitter<number> = new EventEmitter<number>()

    @Input()
    user: User
    @Output()
    userChange: EventEmitter<User> = new EventEmitter<User>()

    /** control for the selected user for server side filtering */
    public userCtrl: FormControl = new FormControl()
    /** control for filter for server side. */
    public userFilteringCtrl: FormControl = new FormControl()
    /** indicate search operation is in progress */
    public searching = false
    /** list of users filtered after simulating server side search */
    public filteredUsers: ReplaySubject<User[]> = new ReplaySubject<User[]>(1)
    /** Subject that emits when the component has been destroyed. */
    protected _onDestroy = new Subject<void>()

    constructor(
        private sharedService: SharedService,
        private userAdminService: UserAdminService // private teacherSchoolService: TeacherSchoolService
    ) {}

    ngOnInit() {
        // get user
        if (this.userId && !this.user) {
            if (this.getAllUsersForAdmin) {
                this.userAdminService.getAll({ id: this.userId }).subscribe((res) => {
                    this.user = res.data?.[0]
                    this.filteredUsers.next([this.user])
                    this.userCtrl.setValue(this.user, { emitEvent: false })
                })
            } else {
                this.userAdminService.getInSalon(this.sharedService.currentSalon.id, this.userId).subscribe((res) => {
                    this.user = res.data
                    this.filteredUsers.next([this.user])
                    this.userCtrl.setValue(this.user, { emitEvent: false })
                })
            }
        }
        this.userCtrl.valueChanges.subscribe((value) => {
            this.user = value
            this.userChange.emit(this.user)
            this.userIdChange.emit(this.user.id)
            console.log('user changed. Id:', this.user?.id)
        })
        // listen for search field value changes
        this.userFilteringCtrl.valueChanges
            .pipe(
                filter((search) => !!search),
                tap(() => (this.searching = true)),
                takeUntil(this._onDestroy),
                debounceTime(200),
                map((keyword) => {
                    // build params
                    const params = {}
                    if (/^\d+$/g.test(keyword)) {
                        // search by phone number
                        params['phoneNumber|like'] = keyword.replace(/^0/, '') + '%'
                    } else {
                        params['fullName|search'] = keyword
                    }

                    if (this.getAllUsersForAdmin) {
                        return {
                            keyword: keyword,
                            request: this.userAdminService.getAll(params),
                        }
                    } else {
                        return {
                            keyword: keyword,
                            request: this.userAdminService.searchInSalon(this.sharedService.currentSalon.id, params),
                        }
                    }
                }),
                delay(500),
                takeUntil(this._onDestroy)
            )
            .subscribe(
                (res) => {
                    if (res.keyword !== this.userFilteringCtrl.value) {
                        return
                    }
                    res.request.usingLoadingBar = false
                    res.request.subscribe(
                        (r: PvsResponse) => {
                            this.searching = false
                            this.filteredUsers.next(r.data)
                        },
                        (err) => {
                            this.searching = false
                            this.sharedService.showErrorMessage(err.errorMessage || err.message)
                        }
                    )
                },
                (error) => {
                    this.searching = false
                    // handle error...
                }
            )
    }

    ngOnDestroy() {
        this._onDestroy.next()
        this._onDestroy.complete()
    }

    onFocus() {
        // console.log('focused')
        // this.filteredServerSideUsers = new ReplaySubject<User[]>(1)
        // console.log('old value', this.userServerSideFilteringCtrl.value)
        // this.userServerSideFilteringCtrl.setValue('', { emitEvent: true })
    }
}
